import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environmentConfig } from '../../environment';
import { Observable, throwError, catchError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HourglassService {
  private apiUrl = environmentConfig.apiBaseUrl;

  constructor(private http: HttpClient) { }

  private fetchAuthenticated(
    url: string,
    method: 'GET' | 'POST' | 'PUT',
    token: string,
    bodyData?: any
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });
    const httpOptions = { headers };
    let httpCall: Observable<any>;
    if (method === 'GET') {
      httpCall = this.http.get(url, httpOptions);
    } else if (method === 'POST') {
      httpCall = this.http.post(url, bodyData, httpOptions);
    } else if (method === 'PUT') {
      httpCall = this.http.put(url, bodyData, httpOptions);
    } else {
      return throwError(() => new Error('Unsupported method'));
    }
    return httpCall.pipe(
      catchError(error => {
        console.error('❌ HTTP Error:', error);
        return throwError(() => error);
      })
    );
  }

//I THINK MOVE TO PFS DATA SERVICE RIGHT?
  getQBInterCompanyRecord(clientID: string, entityA: string, entityB: string): Promise<any> {
    const url = `${this.apiUrl}/api/qb/my_intermapping?cli=${clientID}&enta=${entityA}&entb=${entityB}`;
    const response: any = this.http.get(url).toPromise();
    return response;
  }

  checkTableDelete(table: string, token: string): Promise<any> {
    const url = `${this.apiUrl}/api/dynamicsqlgrid/can_delete?table=${table}`;
    return this.fetchAuthenticated(url, 'GET', token, null).toPromise();
  }

//BELOW IS HOURGLASS BASE FUNTIONALITY
  getTimeEntryUxData(user: string, mode: string, json: object | null, token: string): Promise<any> {
    const url = `${this.apiUrl}/api/hourglass/timeux?user=${user}&mode=${mode}`;
    //const payload = { key_val_pairs: this.sanitizeData(key_val_pairs) };
    return this.fetchAuthenticated(url, 'POST', token, json).toPromise();
  }

  saveTimeEntryEntity(obj: object, token: string): Promise<any> {
    const url = `${this.apiUrl}/api/hourglass/save_entity`;
    return this.fetchAuthenticated(url, 'POST', token, obj).toPromise();
  }

  getTimeEntryTask(id: number, token: string): Promise<any> {
    const url = `${this.apiUrl}/api/hourglass/get_task?id=${id}`;
    return this.fetchAuthenticated(url, 'GET', token, null).toPromise();
  }

  lookupTask(summary: string, userid: number, token: string): Promise<any> {
    const url = `${this.apiUrl}/api/hourglass/lookup_task?summary=${summary}&userid=${userid}`;
    return this.fetchAuthenticated(url, 'GET', token, null).toPromise();
  }

  getUserMetadata(user: string, token: string): Promise<any> {
    const url = `${this.apiUrl}/api/ux/usermeta?id=${user}`;
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this.http.get(url, { headers }).toPromise();
  }

  getUserMetadataEmail(user: string, token: string): Promise<any> {
    const url = `${this.apiUrl}/api/ux/usermetaemail?email=${user}`;
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this.http.get(url, { headers }).toPromise();
  }

//SUBMIT WEEKLY UPDATE SERVICE FUNCTIONS  
  saveWeeklyNotes(obj: object, token: string): Promise<any> {
    const url = `${this.apiUrl}/api/hourglass/save_weekly_notes`;
    return this.fetchAuthenticated(url, 'POST', token, obj).toPromise();
  }

  loadWeeklyReportData(user: number, year: number, week: number, token: string): Promise<any> {
    const url = `${this.apiUrl}/api/hourglass/get_weekly_data?uid=${user}&yr=${year}&wk=${week}`;
    //const payload = { key_val_pairs: this.sanitizeData(key_val_pairs) };
    return this.fetchAuthenticated(url, 'GET', token, null).toPromise();
  }

  sendWeeklyEmail(title: any, user: string, wk: string, yr: string, to: string): Promise<any> {
    const url = `${this.apiUrl}/api/rpt/weekly?title=${title}&user=${user}&wk=${wk}&yr=${yr}&to=${to}`;
    console.log(url)
    const response: any = this.http.post(url, null).toPromise();
    return response;
  }

///BILLING REVIEW GRID(ADMIN ONLY SERVICE FUNCTIONS)
  updateTimeLog(logData: any, token: string): Promise<any> {
    const url = `${this.apiUrl}/api/hourglass/review/updatetimelog`;
    return this.fetchAuthenticated(url, 'POST', token, logData).toPromise();
  }

  getReviewRefCols(token: string): Promise<any> {
    const url = `${this.apiUrl}/api/hourglass/review/refcols`;
    return this.fetchAuthenticated(url, 'GET', token).toPromise();
  }

  getAllTaskTimeLogs(token: string): Promise<any> {
    const url = `${this.apiUrl}/api/hourglass/review/timelogs`;
    return this.fetchAuthenticated(url, 'GET', token).toPromise();
  }

//USER GROUPS TOOL
  getUserGroups(token: string) {
    const url = `${this.apiUrl}/api/hourglass/get_usergroups`;
    return this.fetchAuthenticated(url, 'GET', token).toPromise();
  }

  saveUserGroup(mode: string, obj: object, token: string): Promise<any> {
    const url = `${this.apiUrl}/api/hourglass/save_usergroups?mode=${mode}`;
    return this.fetchAuthenticated(url, 'POST', token, obj).toPromise();
  }

  saveTaskMerge(obj: object, token: string): Promise<any> {
    const url = `${this.apiUrl}/api/hourglass/save_taskmerge`;
    return this.fetchAuthenticated(url, 'POST', token, obj).toPromise();
  }


}
